import { toConsumableArray as _toConsumableArray, objectSpread2 as _objectSpread2, defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { t } from '../../i18n/translate.js';
import '../../components/Button/Button.js';
import '../../components/AppLogo/AppLogo.js';
import '../../components/Avatar/Avatar.js';
import Input from '../../components/Input/Input.js';
import '../../components/Input/PasswordInput.js';
import '../../components/Icon/Icon.js';
import '../../components/Image/Image.js';
import 'classnames';
import '../../components/LoadingSpinner/LoadingSpinner.module.scss.js';
import '../../components/Note/Note.js';
import '../../components/RadioButton/RadioButton.js';
import '../../components/RoundButton/RoundButton.js';
import '../../components/RoundButton/RoundButtonElement/RoundButtonElement.js';
import '../../components/Expandable/Expandable.js';
import '../../components/PopOver/PopOver.js';
import '../../components/Wizard/Wizard.js';
import '../../components/Wizard/WizardStepContent/WizardStepContent.js';
import '../../components/Wizard/NavigationBar/NavigationBar.js';
import '../../components/ToggleButton/ToggleButton.js';
import '../../components/ToggleButton/ToggleButtonElement/ToggleButtonElement.js';
import '../../components/Wizard/ProgressBar/ProgressBar.js';
import '../../components/Checkbox/Checkbox.js';
import '../../components/SelectionField/SelectionField.js';
import '../../components/Card/Card.js';
import '../../components/Badge/Badge.js';
import '../../components/SettingsItem/SettingsItem.js';
import '../../components/SortableList/SortableList.js';
import '../../components/Contacts/ContactItem.js';
import '../../components/TopElement/TopElement.js';
import '../../components/SidePanelInfoBox/SidePanelInfoBox.js';
import '../../components/Flag/Flag.js';
import '../../i18n/i18n.js';
import '../../services/apiEndpoint/apiEndpoint.js';
import { NAME_MAX_LENGTH, INPUT_FIELD_DEFAULT_MIN_LENGTH, STREET_NAME_LENGTH, CO_LENGTH, CITY_NAME_LENGTH, ZIP_NUMBER_LENGTH, PHONE_MAX_LENGTH, PHONE_MIN_LENGTH } from '../../services/appConstants/appConstants.js';
import '../../node_modules/tslib/tslib.es6.js';
import 'react-ga4';
import { isValidLikeMGW, isZipCodeValid, isPhoneNumberValid } from '../../services/utilities/validation.js';
import { cleanPhoneNumber, formatPhone } from '../../services/utilities/phoneNumberUtil.js';
import '../../services/utilities/countries.js';
import '@sentry/react';
import '@apollo/client';
import '@apollo/client/link/batch-http';
import '@apollo/client/link/error';
import 'uuid';
import '../../services/graphql/default-client/DefaultClient.js';
import 'axios';
import 'date-fns/isAfter';
import 'date-fns/addMinutes';
import '../../services/logout/rest-default-client/restDefaultClient.js';
import '../../services/poller/PollManager.js';
import 'react-dom';
import 'react-redux';
import '../../services/ipcWeb/IpcContext.js';
import 'js-cookie';
import 'react-i18next';
import '../../services/translation/translationUtils.module.scss.js';
import '../../services/utilities/languageUtil.js';
import '../../services/useContactUs/ContactUs.gql.js';
import '../../services/storageHandler/StorageHandler.js';
import '../../services/abortablePromise/AbortablePromise.js';
import '../../services/abortablePoller/AbortablePoller.js';
import '../../services/abortablePoller/ResumablePoller.js';
import '../../components/DropDownBox/DropDownBox.module.scss.js';
import '../../components/PhoneSelectButton/PhoneSelectButton.module.scss.js';
import '../../components/InternationalPhonePicker/InternationalPhonePicker.module.scss.js';
import '../../components/Carousel/ImageCarousel.module.scss.js';
import styles from './BillingAddressForm.module.scss.js';

var BillingAddressForm = function BillingAddressForm(_ref) {
  var dealerSettings = _ref.dealerSettings,
    newBillingAddress = _ref.newBillingAddress,
    setNewBillingAddress = _ref.setNewBillingAddress,
    setIsBillingFormValid = _ref.setIsBillingFormValid,
    disable = _ref.disable;
  var handleFieldChange = function handleFieldChange(value, name) {
    setNewBillingAddress(_objectSpread2(_objectSpread2({}, newBillingAddress), {}, _defineProperty({}, name, value)));
  };
  var zipCodeRegex = dealerSettings.zipCodeRegex,
    showBillingPhoneNumber = dealerSettings.showBillingPhoneNumber;
  var firstName = newBillingAddress.firstName,
    lastName = newBillingAddress.lastName,
    street = newBillingAddress.street,
    street2 = newBillingAddress.street2,
    city = newBillingAddress.city,
    zip = newBillingAddress.zip,
    phone = newBillingAddress.phone;
  var handlePhoneChange = function handlePhoneChange(value, name) {
    var cleanPhone = cleanPhoneNumber(value);
    handleFieldChange(formatPhone(cleanPhone), name);
  };
  var validateField = function validateField(value, validationFunction, errorMessage) {
    var error = !validationFunction(value);
    var errorMsg = error ? errorMessage : '';
    return {
      error: error,
      errorMsg: errorMsg
    };
  };
  var nameValidator = validateField(firstName, isValidLikeMGW, t('MPLIB_ERROR_INVALID_CHARS'));
  var lastNameValidator = validateField(lastName, isValidLikeMGW, t('MPLIB_ERROR_INVALID_CHARS'));
  var zipValidator = validateField(zip, function (value) {
    return !value || isZipCodeValid(value, zipCodeRegex);
  }, t('MPLIB_ERROR_ZIP_CODE_WRONG_FORMAT'));
  var coValidator = validateField(street2, isValidLikeMGW, t('MPLIB_ERROR_INVALID_CHARS'));
  var streetValidator = validateField(street, isValidLikeMGW, t('MPLIB_ERROR_INVALID_CHARS'));
  var cityValidator = validateField(city, isValidLikeMGW, t('MPLIB_ERROR_INVALID_CHARS'));
  var phoneValidator = validateField(phone, function (value) {
    return !value || isPhoneNumberValid(value);
  }, t('MPLIB_ERROR_INVALID_PHONE_NUMBER'));
  var validFields = [nameValidator, lastNameValidator, streetValidator, coValidator, cityValidator, zipValidator].concat(_toConsumableArray(showBillingPhoneNumber ? [phoneValidator] : [])).every(function (field) {
    return !field.error;
  });
  var noEmptyMandatoryFields = [lastName, street, city, zip].concat(_toConsumableArray(showBillingPhoneNumber ? [phone] : [])).every(function (field) {
    return Boolean(field === null || field === void 0 ? void 0 : field.trim());
  });
  useEffect(function () {
    setIsBillingFormValid(validFields && noEmptyMandatoryFields);
  }, [firstName, lastName, street, city, zip, phone]);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.bottomspace
  }, /*#__PURE__*/React.createElement(Input, {
    placeholder: t('MPLIB_FIRSTNAME'),
    value: firstName,
    onChange: function onChange(value, _, name) {
      return handleFieldChange(value, name);
    },
    dataTestId: "billing-address-name",
    name: "firstName",
    maxLength: NAME_MAX_LENGTH,
    hasError: nameValidator.error,
    errorMessage: nameValidator.errorMsg,
    disabled: disable
  }), /*#__PURE__*/React.createElement(Input, {
    onChange: function onChange(value, _, name) {
      return handleFieldChange(value, name);
    },
    placeholder: t('MPLIB_LASTNAME'),
    value: lastName,
    name: "lastName",
    minLength: INPUT_FIELD_DEFAULT_MIN_LENGTH,
    maxLength: NAME_MAX_LENGTH,
    dataTestId: "billing-address-lastname",
    hasError: lastNameValidator.error,
    errorMessage: lastNameValidator.errorMsg,
    disabled: disable,
    mandatory: true
  }), /*#__PURE__*/React.createElement(Input, {
    onChange: function onChange(value, _, name) {
      return handleFieldChange(value, name);
    },
    placeholder: t('MPLIB_ADDRESS_STREET'),
    dataTestId: "billing-address-street",
    value: street,
    minLength: INPUT_FIELD_DEFAULT_MIN_LENGTH,
    maxLength: STREET_NAME_LENGTH,
    hasError: streetValidator.error,
    errorMessage: streetValidator.errorMsg,
    name: "street",
    disabled: disable,
    mandatory: true
  }), /*#__PURE__*/React.createElement(Input, {
    onChange: function onChange(value, _, name) {
      return handleFieldChange(value, name);
    },
    placeholder: t('MPLIB_ADDRESS_CO'),
    dataTestId: "billing-address-co",
    value: street2,
    maxLength: CO_LENGTH,
    hasError: Boolean(street2) && coValidator.error,
    errorMessage: coValidator.errorMsg,
    name: "street2",
    disabled: disable
  }), /*#__PURE__*/React.createElement(Input, {
    onChange: function onChange(value, _, name) {
      return handleFieldChange(value, name);
    },
    placeholder: t('MPLIB_ADDRESS_CITY'),
    dataTestId: "billing-address-city",
    value: city,
    minLength: INPUT_FIELD_DEFAULT_MIN_LENGTH,
    maxLength: CITY_NAME_LENGTH,
    hasError: cityValidator.error,
    errorMessage: cityValidator.errorMsg,
    name: "city",
    disabled: disable,
    mandatory: true
  }), /*#__PURE__*/React.createElement(Input, {
    onChange: function onChange(value, _, name) {
      return handleFieldChange(value, name);
    },
    placeholder: t('MPLIB_ADDRESS_ZIP'),
    dataTestId: "billing-address-zip",
    value: zip,
    minLength: INPUT_FIELD_DEFAULT_MIN_LENGTH,
    maxLength: ZIP_NUMBER_LENGTH,
    hasError: zipValidator.error,
    errorMessage: zipValidator.errorMsg,
    name: "zip",
    disabled: disable,
    mandatory: true
  }), showBillingPhoneNumber && /*#__PURE__*/React.createElement(Input, {
    onChange: function onChange(value, _, name) {
      return handlePhoneChange(value, name);
    },
    placeholder: t('MPLIB_ADDRESS_PHONE'),
    dataTestId: "billing-address-phone",
    value: phone,
    minLength: PHONE_MIN_LENGTH,
    maxLength: PHONE_MAX_LENGTH,
    hasError: phoneValidator.error,
    errorMessage: phoneValidator.errorMsg,
    name: "phone",
    disabled: disable,
    mandatory: true
  }));
};
BillingAddressForm.propTypes = {
  setIsBillingFormValid: PropTypes.func.isRequired,
  setNewBillingAddress: PropTypes.func.isRequired,
  disable: PropTypes.bool,
  newBillingAddress: PropTypes.shape({
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    street: PropTypes.string.isRequired,
    zip: PropTypes.string.isRequired,
    phone: PropTypes.string.isRequired,
    city: PropTypes.string.isRequired,
    street2: PropTypes.string
  }).isRequired,
  dealerSettings: PropTypes.shape({
    zipCodeRegex: PropTypes.string.isRequired,
    showBillingPhoneNumber: PropTypes.bool.isRequired
  }).isRequired
};
BillingAddressForm.defaultProps = {
  disable: false
};

export { BillingAddressForm };
